import { useState, useEffect, useRef, createRef } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import PageTopTitle from "../../components/shared/PageTopTitle";
import Pagination from "../../components/shared/Pagination";
import ItemContainer from "../../components/topList/loadList/item/ItemContainer";
import ItemContainerWide from "../../components/topList/loadList/item/ItemContainerWide";
import SmallSpinner from "../../components/shared/spinners/SmallSpinner";
import useWindowDimensions from "../../hooks/useWindowSize";
import ItemMobileContainer from "../../components/topList/loadList/item/ItemMobileContainer";
import LoadListTopContainer from "../../components/topPages/topContainer/LoadListTopContainer";
import { getAracTypes } from "../../features/adminSett/adminSettSlice";
import InputSelectLoadListFilter from "../../components/shared/input/special/InputSelectLoadListFilter";
import { getAdminCompanyLoadFilter } from "../../features/loadList/loadListSlice";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      gap: 60px;
      margin: 0 30px;
      margin-top: 30px;

      /* display: flex;
            flex-direction: column;
            gap: 40px; */
      .top-filter-admin{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        margin-bottom: 20px;
      }
      .top-container {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        margin-bottom: 20px;

        .filter-wrapper {
          position: relative;
          width: 100%;

          .filter-container {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 5;
            border: 2px solid var(--color-main);
            background-color: ${({ theme }) => theme.mainBgColor};
            padding: 20px;
            border-radius: 10px;
            width: auto;
            height: auto;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .container-item {
              width: 100%;
              display: flex;
              align-items: center;
              gap: 10px;
            }
          }
        }
      }

      .load-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        .loading{
          min-height: 30vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .pagination-container {
      gap: 60px;
      margin: 0 30px;
      margin-top: 20px;
      height: 200px;
    }
  }

  /* .asdas{
        width: 100%;
        height: 400px;
        background-color: rebeccapurple;
    } */
`;

const LoadList = () => {
  const dispatch = useDispatch();
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const rld = JSON.parse(storage.getItem("rld"))


  const {windowDimensions} = useWindowDimensions()

  const [currentPage, setCurrentPage] = useState(1);

  const elementRef = useRef(null);

  const [activeItemId, setActiveItemId] = useState(null);

  const { loadList, loadListQuantity, isLoadingGetLoadlist, selectedLoadListCompany, loadListCompanyList  } = useSelector((state) => state.loadList);
  const itemRefs = useRef([]);

  useEffect(() => {
    dispatch(getAracTypes())
  },[])
  useEffect(() => {
    if(rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" || rld === "f84f35ab-0eb1-46a4-84f4-e72b236c3d26" || rld === "a7b53ef7-1cf6-4720-9b13-d9f81b5a0f99"){
        dispatch(getAdminCompanyLoadFilter())
    }
  },[])


  useEffect(() => {
    itemRefs.current = loadList.map(() => createRef());
  }, [loadList]);

  const itemsPerPage = 50;
  const totalPages = Math.ceil(loadListQuantity / itemsPerPage);

  //! kapalıydı açıldı
  // useEffect(() => {
  //     dispatch(getLoadList({
  //         currentPage,
  //         isParsiyel: 0,
  //         loadCity: "",
  //         unLoadCity: "",
  //         companyName: "",
  //         loadDate: "",
  //         truckType: "",
  //     }))
  // },[currentPage])

  const scrollToMiddle = (activeItemId) => {
    const matchedItem = loadList.find((item) => item.id === activeItemId);
    if (matchedItem) {
      const element = document.getElementById(matchedItem.id);
      if (element) {
        elementRef.current = element;
        elementRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Yükler Listesi"} position="sticky" />
        <div className="content">
            {"db7bb061-0f64-4eae-9c4f-678a7359fd01" === rld &&
              <div className="top-filter-admin">
                <InputSelectLoadListFilter data={selectedLoadListCompany} labelText={"Firma Adı"} inputWidth={"300px"} initialOptions={loadListCompanyList} name={"selectedLoadListCompany"} />
              </div>
            }
            <LoadListTopContainer currentPage={currentPage}/>
          <div className="load-list">
          {isLoadingGetLoadlist ? (
              <div className="loading">
                <SmallSpinner size={"65px"} color={"#fff"} bgColor={"#E85446"} />
              </div>
            ) : (
              <>
                {loadList?.map((item, i) => {
                  const width = windowDimensions?.width;
                  const isActive = item.id === activeItemId;

                  let ItemComponent;
                  if (width < 850) {
                    ItemComponent = ItemMobileContainer; 
                  } else if (width < 1150 || isActive) {
                    ItemComponent = ItemContainerWide;
                  } else {
                    ItemComponent = ItemContainer;
                  }
                  return (
                    <ItemComponent
                      key={item.id}
                      item={item}
                      setActiveItemId={setActiveItemId}
                      activeItemId={activeItemId}
                      forwardRef={itemRefs.current[i]}
                      handleClick={scrollToMiddle}
                      list={loadList}
                    />
                  );
                })}
              </>
            )
          }
          </div>
        </div>
        <div className="pagination-container">
          {(loadList || loadList?.length > 0) && (
            <Pagination
              totalPages={totalPages}
              handleClick={setCurrentPage}
              currentPage={currentPage}
            />
          )}

          {/* {
                list.map((item, i) => (
                    <div className="asdas" ref={itemRefs.current[i]} onClick={() => scrollToMiddle(i)}>item</div>
                ))
            } */}
        </div>
      </div>
    </Container>
  );
};

export default LoadList;
